// extracted by mini-css-extract-plugin
var _1 = "ButtonIcon-moduleicon__Hawdx IconNG-moduleiconContainer__SxWZ0";
export { _1 as "icon" }
